import styled from 'styled-components';

export const StyledCheckboxGroup = styled.fieldset`
    border: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;

    &.checkbox-option-group label > div > div > div {
        margin-right: 9px;
    }
`;
